export default function TermsOfService() {
	return (
		<div className="min-h-screen bg-vscode-bg">
			{/* Header */}
			<section className="bg-vscode-editor border-b border-vscode-border py-20">
				<div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
					<h1 className="text-4xl font-semibold text-vscode-text-bright mb-4 font-sans">
						Terms of Service
					</h1>
					<p className="text-lg text-vscode-text-muted font-mono">
						Last Updated: November 22, 2025
					</p>
				</div>
			</section>

			{/* Content */}
			<section className="py-12">
				<div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
					<div className="prose prose-invert max-w-none">
						<div className="space-y-8 text-vscode-text font-mono">
							<section>
								<h2 className="text-2xl font-semibold text-vscode-text-bright mb-4 font-sans">1. Acceptance of Terms</h2>
								<p className="text-vscode-text-muted mb-4">
									By accessing and using SakaDev ("the Service"), you accept and agree to be bound by the terms and 
									provision of this agreement. If you do not agree to abide by the above, please do not use this service.
								</p>
							</section>

							<section>
								<h2 className="text-2xl font-semibold text-vscode-text-bright mb-4 font-sans">2. Use License</h2>
								<p className="text-vscode-text-muted mb-4">
									Permission is granted to temporarily download one copy of SakaDev per device for personal, 
									non-commercial transitory viewing only. This is the grant of a license, not a transfer of title.
								</p>
								<p className="text-vscode-text-muted mb-4">Under this license you may not:</p>
								<ul className="list-disc list-inside space-y-2 text-vscode-text-muted ml-4">
									<li>Modify or copy the materials</li>
									<li>Use the materials for any commercial purpose or for any public display</li>
									<li>Attempt to reverse engineer any software contained in SakaDev</li>
									<li>Remove any copyright or other proprietary notations from the materials</li>
									<li>Transfer the materials to another person or "mirror" the materials on any other server</li>
								</ul>
							</section>

							<section>
								<h2 className="text-2xl font-semibold text-vscode-text-bright mb-4 font-sans">3. API Usage and Credits</h2>
								<p className="text-vscode-text-muted mb-4">
									SakaDev may offer API access and credit-based services. By using these services:
								</p>
								<ul className="list-disc list-inside space-y-2 text-vscode-text-muted ml-4">
									<li>You agree to pay for any credits purchased</li>
									<li>Credits are non-refundable unless required by law</li>
									<li>Credit balances do not expire unless specified otherwise</li>
									<li>We reserve the right to modify pricing with 30 days notice</li>
									<li>Rate limits may apply to prevent abuse</li>
								</ul>
							</section>

							<section>
								<h2 className="text-2xl font-semibold text-vscode-text-bright mb-4 font-sans">4. User Content</h2>
								<p className="text-vscode-text-muted mb-4">
									You retain all rights to any code, content, or data you create using SakaDev. By using the Service, 
									you grant us a limited license to process your content solely for the purpose of providing the Service.
								</p>
							</section>

							<section>
								<h2 className="text-2xl font-semibold text-vscode-text-bright mb-4 font-sans">5. Privacy and Data</h2>
								<p className="text-vscode-text-muted mb-4">
									Your use of SakaDev is also governed by our Privacy Policy. Please review our Privacy Policy, 
									which also governs the Service and informs users of our data collection practices.
								</p>
							</section>

							<section>
								<h2 className="text-2xl font-semibold text-vscode-text-bright mb-4 font-sans">6. Disclaimer</h2>
								<p className="text-vscode-text-muted mb-4">
									The materials on SakaDev are provided on an 'as is' basis. SakaDev makes no warranties, 
									expressed or implied, and hereby disclaims and negates all other warranties including, without 
									limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, 
									or non-infringement of intellectual property or other violation of rights.
								</p>
							</section>

							<section>
								<h2 className="text-2xl font-semibold text-vscode-text-bright mb-4 font-sans">7. Limitations</h2>
								<p className="text-vscode-text-muted mb-4">
									In no event shall SakaDev or its suppliers be liable for any damages (including, without limitation, 
									damages for loss of data or profit, or due to business interruption) arising out of the use or 
									inability to use SakaDev, even if SakaDev or a SakaDev authorized representative has been notified 
									orally or in writing of the possibility of such damage.
								</p>
							</section>

							<section>
								<h2 className="text-2xl font-semibold text-vscode-text-bright mb-4 font-sans">8. Modifications</h2>
								<p className="text-vscode-text-muted mb-4">
									SakaDev may revise these terms of service at any time without notice. By using this Service you 
									are agreeing to be bound by the then current version of these terms of service.
								</p>
							</section>

							<section>
								<h2 className="text-2xl font-semibold text-vscode-text-bright mb-4 font-sans">9. Governing Law</h2>
								<p className="text-vscode-text-muted mb-4">
									These terms and conditions are governed by and construed in accordance with the laws and you 
									irrevocably submit to the exclusive jurisdiction of the courts in that location.
								</p>
							</section>

							<section>
								<h2 className="text-2xl font-semibold text-vscode-text-bright mb-4 font-sans">10. Contact Information</h2>
								<p className="text-vscode-text-muted mb-4">
									If you have any questions about these Terms of Service, please contact us:
								</p>
								<ul className="list-none space-y-2 text-vscode-text-muted ml-4">
									<li>Email: <a href="mailto:support@sakadev.site" className="text-vscode-accent hover:text-vscode-text-bright">support@sakadev.site</a></li>
									<li>GitHub: <a href="https://github.com/rahmanazhar/SakaDev" target="_blank" rel="noopener noreferrer" className="text-vscode-accent hover:text-vscode-text-bright">github.com/rahmanazhar/SakaDev</a></li>
								</ul>
							</section>
						</div>
					</div>
				</div>
			</section>
		</div>
	)
}
